import { takeLatest, takeLeading } from 'redux-saga/effects';
import submitInfo from './submitInfo';
import saveProfileData from './saveProfileData';
import getExamSeries from './getExamSeriesData';
import getExamCentres from './getExamCentresData';
import getInstitutions from './getInstitutionsData';
import saveExamDetailsData from './saveExamDetailsData';
import saveInstitutionDetailsData from './saveInstitutionDetailsData';
import getTranscriptsCost from './getTranscriptsCost';
import getTranscriptHistory from './getTranscriptHistory';
import getTransactionSummary from './getTransactionSummary';
import acceptedTerms from './acceptedTerms';
import getTerms from './getTerms';

import { 
  SAVE_PERSONAL_INFO_DATA,
  SUBMIT_INFO,
  GET_EXAM_CENTRE_LIST,
  GET_INSTITUTION_LIST,
  GET_EXAM_SERIES,
  SAVE_EXAM_DETAILS,
  SAVE_INSTITUTION_DETAILS,
  GET_TRANSRIPT_COSTS,
  GET_TRANSACTION_HISTORY,
  GET_TRANSACTION_SUMMARY,
  TERMS_CONDITIONS_ACCEPTED,
  GET_TERMS_CONDITIONS
 } from './../actionTypes';


export default function * sagaWatcher () {
  yield takeLatest(SAVE_PERSONAL_INFO_DATA, saveProfileData)
  yield takeLatest(SUBMIT_INFO, submitInfo)
  yield takeLatest(GET_EXAM_SERIES, getExamSeries)
  yield takeLeading(GET_EXAM_CENTRE_LIST, getExamCentres)
  yield takeLeading(GET_INSTITUTION_LIST, getInstitutions)
  yield takeLatest(SAVE_EXAM_DETAILS, saveExamDetailsData)
  yield takeLatest(SAVE_INSTITUTION_DETAILS, saveInstitutionDetailsData)
  yield takeLatest(GET_TRANSRIPT_COSTS, getTranscriptsCost)
  yield takeLatest(GET_TRANSACTION_HISTORY, getTranscriptHistory)
  yield takeLatest(GET_TRANSACTION_SUMMARY, getTransactionSummary)
  yield takeLatest(TERMS_CONDITIONS_ACCEPTED, acceptedTerms)
  yield takeLatest(GET_TERMS_CONDITIONS, getTerms)  
}